 var timeout;
 var fade;

$(document).ready(function(){

  fade = function(){
  clearTimeout(timeout);

  $(".canvas div.active").animate({opacity: "0"}, 2000, 'swing', function(){
    $(this).removeClass("active");
  });

  var nextElm;

  if($(".canvas div.active").next(".item").length > 0){
   nextElm = $(".canvas div.active").next(".item");
  }
  else{
   nextElm = $(".canvas .item:eq(0)");
  }

  $(".position a.active").removeClass("active").addClass("inactive");
  $(".position a[href='#"+$(nextElm).attr('id')+"']").removeClass("inactive").addClass("active");

  $(nextElm).animate({opacity: "1"}, 2000, 'swing', function(){
    $(this).addClass("active");

    timeout = setTimeout(fade, 9000);
  });
 }

 $(".slider-header .position a").each(function(){
   $(this).click(function(){
     clearTimeout(timeout);
     
     $(".canvas .item").stop();
     $(".canvas .item").each(function(){
       $(this).css("opacity", "0");
     });

     $(".canvas div.active").removeClass("active");

     $(".position a.active").removeClass("active").addClass("inactive");
     $(this).removeClass("inactive").addClass("active");

     $("#"+$(this).attr("href").substring(1)).animate({opacity: "1"}, 2000, 'swing', function(){
       $(this).addClass("active");
       timeout = setTimeout(fade, 9000);
     });
     
     return false;
   });
 });
 
 $('#matrix a').css('opacity', '0.7');
 
 $("#matrix a").hover(
  function () {
    $(this).css('opacity', '1');
  }, 
  function () {
    $(this).css('opacity', '0.7');
  }
 );


});


$(window).load(function () {
  $(".canvas .item").each(function(){
   $(this).css("opacity", "0");
   $(this).css("display", "block");
  });

  $(".canvas .item:eq(0)").animate({opacity: "1"}, 1000, function(){
    $(this).addClass("active");

    timeout = setTimeout(fade, 5000);
  });
});



